import axios from "./axios"

const getUsersListApi = async () => {
	return await axios.get(`/user`).then((data) => {
		return data
	})
}

const createUserAPI = async (payload) => {
	return await axios
		.post(`/user`, payload)
		.then((response) => {
			return response
		})
		.catch((error) => {
			console.log("Error", error)
			return error
		})
}

const deleteUserAPI = async (payload) => {
	const api = `/user/${payload?.userid}`
	return await axios
		.delete(api, payload)
		.then((response) => {
			return response
		})
		.catch((error) => {
			console.log("Error", error)
			return error
		})
}

const checkEmailAvailabilityAPI = async (payload) => {
	const api = `/user/username_exists/${encodeURIComponent(payload?.email)}`
	return await axios
		.get(api, payload)
		.then((response) => {
			return response
		})
		.catch((error) => {
			console.log("Error", error)
			return error
		})
}

const updateUserAPI = async (payload) => {
	const api = `/user/${payload?.userid}`
	delete payload?.confirmPassword
	delete payload?.userid
	return await axios
		.put(api, payload)
		.then((response) => {
			return response
		})
		.catch((error) => {
			console.log("Error", error)
			return error
		})
}

const getCaseListAPI = async (payload) => {
	return await axios
		.get(`/case`, payload)
		.then((response) => {
			return response
		})
		.catch((error) => {
			console.log("Error", error)
			return error
		})
}

export const usersService = {
	getUsersListApi,
	createUserAPI,
	deleteUserAPI,
	checkEmailAvailabilityAPI,
	updateUserAPI,
	getCaseListAPI,
}
